import { useState, useEffect } from "react";

//** Context */
import usePreQualificationPages from "../hooks/usePreQualificationPages";
import usePreQualification from "../hooks/usePreQualification";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { OKTA_LOGIN_PAGE } from "../context/auth/types";

// const loadFirstPage = async (funcs, funcSet) => {
//   funcs.resetData(); // Make sure we clear down the data.
//   const responsePage = funcs.getStartPage();
//   return <Navigate replace to={responsePage.responsePage.routePath} />;
// };

export default function CCPageGuard({ children }) {
	try {
		const { pathname } = useLocation();
		const { funcs } = usePreQualificationPages();
		const { funcSet } = usePreQualification();
		const { getOktaAccessToken, setAuthenticationDetails } = useAuth();
		const [isCCAgentAuthenticated, setIsCCAgentAuthenticated] = useState(false);

		// !! Check to ensure that we can go to a specific page
		// !! If the page is valid or the  page is next in the page sequence, allow access
		// !! else return to the last valid page.

		// ? Get this from the Pages Context - Pass in the index of the page we are trying to access
		const pageIndex = { ...children }.props.pageIndex;

		useEffect(() => {
			async function initialize() {
				try {
					let oktaAccessToken = await getOktaAccessToken();
					if (oktaAccessToken) {
						setIsCCAgentAuthenticated(true);
						setAuthenticationDetails(true);
					} else {
						//not a valid OKta Access token redirect to the okta login page
						setIsCCAgentAuthenticated(false);
						window.location.href = OKTA_LOGIN_PAGE;
					}
				} catch (err) {
					console.error("Error occurred while calling Okta library - ", err);
				}
			}
			initialize();
		}, [pathname]);

		// Ensure we are allowed to navigate to the requested page
		const responsePage = funcs.getRequestPage({
			requestPageIndex: pageIndex,
		});
		// Check if this is a navigation 'back'
		if (
			responsePage.allowPageRequest === false ||
			responsePage.isBack === true
		) {
			return <Navigate to={responsePage.responsePage.previousRoutePath} />;
		}

		// No issue, load the page.
		return <>{children}</>;
	} catch (ex) {
		console.error(ex);
	}
}
